<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2
    [titulo]="DAT_TITULOS.titulo"
    [modulo]="GLOBAL_TITULOS.modulo"
    [tituloCard]="DAT_TITULOS.tituloCardList"
    [innTemplate]="enviarTemplateEdit"
    [innTemplateButton]="innTemplateButton">
  </app-lfsa-card-v2>

  <!-- OPCIONES BOTONES IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-success" [disabled]="!parentSelectedId">
            <i aria-hidden="true" class="fa fa-plus"></i> Agregar Parámetro 
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #enviarTemplateEdit>
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label"><b>Seleccione Parámetro Padre:</b></label>
        <ng-select [items]="listParents"
                   bindValue="idParametro"
                   bindLabel="descripcionParametro"
                   placeholder="Seleccione un parámetro padre"
                   [(ngModel)]="parentSelectedId"
                   (change)="onParentChange($event)">
        </ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label"><b>Buscar en la tabla:</b></label>
        <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar" (keyup)="onQuickFilterChanged()" />
      </div>
    </div>

    <!-- GRILLA -->
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                    [id]="DAT_AG_GRID.id" 
                    [class]="DAT_AG_GRID.class" 
                    [ngStyle]="DAT_AG_GRID.style" 
                    [rowData]="rowData" 
                    [rowSelection]="'single'"
                    [columnDefs]="columnDefs"
                    [pagination]="DAT_AG_GRID.pagination" 
                    [paginationPageSize]="DAT_AG_GRID.pagina"
                    [defaultColDef]="defaultColDef"
                    [frameworkComponents]="frameworkComponents">
    </ag-grid-angular>
  </ng-template>
</div>

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="abrirModalTemplate" [classModal]="'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
    [idOpen]="'Modal'" [idClose]="'cerrarModal'" [titulo]="titleModal">
</app-lfsa-modal>

<ng-template #abrirModalTemplate>
  <div class="container-fluid">
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="col-md-4">
          <app-lfsa-input formControlName="idParametro" [label]="'ID'" [id]="'idParametro'" 
            [control]="formulario.get('idParametro')" [type]="'number'" class="form-control-sm" [isReadOnly]="true">
          </app-lfsa-input>
        </div>
        <div class="col-md-8">
          <app-lfsa-input formControlName="nombreParametro" [label]="'* Nombre (Código)'" [id]="'nombreParametro'" 
            [control]="formulario.get('nombreParametro')" [type]="'text'" class="form-control-sm">
          </app-lfsa-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <app-lfsa-input formControlName="descripcionParametro" [label]="'* Descripción'" [id]="'descripcionParametro'" 
            [control]="formulario.get('descripcionParametro')" [type]="'text'" class="form-control-sm">
          </app-lfsa-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <app-lfsa-input formControlName="valorParametroStr" [label]="'Valor String'" [id]="'valorParametroStr'" 
            [control]="formulario.get('valorParametroStr')" [type]="'text'" class="form-control-sm">
          </app-lfsa-input>
        </div>
        <div class="col-md-4">
          <app-lfsa-input formControlName="valorParametroNum" [label]="'Valor Numérico'" [id]="'valorParametroNum'" 
            [control]="formulario.get('valorParametroNum')" [type]="'number'" class="form-control-sm">
          </app-lfsa-input>
        </div>
        <div class="col-md-4">
          <app-lfsa-input formControlName="orden" [label]="'Orden'" [id]="'orden'" 
            [control]="formulario.get('orden')" [type]="'number'" class="form-control-sm">
          </app-lfsa-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-lfsa-combo-box [label]="'* Tipo'" formControlName="tipoParametro" [control]="formulario.get('tipoParametro')" 
                              [comboBox]="cmbxTipoParametro" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
          </app-lfsa-combo-box>
        </div>
        <div class="col-md-6">
          <app-lfsa-combo-box [label]="'* Estado'" formControlName="estado" [control]="formulario.get('estado')" 
                              [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
          </app-lfsa-combo-box>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-secondary mr-2" (click)="closeModal()">Cancelar</button>
          <button type="button" class="btn btn-primary" [disabled]="formulario.invalid || loading" (click)="saveForm()">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<app-lfsa-modal [innTemplate]="abrirModalCentroTemplate" [classModal]="'modal-dialog modal-md'" [idButton]="'abrirModalCentro'" 
    [idOpen]="'ModalCentro'" [idClose]="'cerrarModalCentro'" [titulo]="titleModalCentro">
</app-lfsa-modal>

<ng-template #abrirModalCentroTemplate>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <label class="form-label"><b>* Centro</b></label>
        <ng-select [items]="listCentrosDestinos"
                   bindValue="idCentro"
                   bindLabel="descripcion"
                   placeholder="Seleccione un centro"
                   [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="centroSelectedId">
        </ng-select>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 text-center">
        <button type="button" class="btn btn-secondary mr-2" (click)="closeCentroModal()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="!centroSelectedId || loading" (click)="saveCentroParametro()">
          <i class="fa fa-save"></i> {{ isCreateCentro ? 'Añadir' : 'Actualizar' }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<app-lfsa-modal [innTemplate]="abrirModalUsuarioTemplate" [classModal]="'modal-dialog modal-md'" [idButton]="'abrirModalUsuario'" 
    [idOpen]="'ModalUsuario'" [idClose]="'cerrarModalUsuario'" [titulo]="titleModalUsuario">
</app-lfsa-modal>

<ng-template #abrirModalUsuarioTemplate>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <label class="form-label"><b>* Usuario</b></label>
        <ng-container *ngIf="(empleadosActivos$ | async) as response; else loadingUsuarios">
          <ng-select [items]="response"
                     bindLabel="nombres"
                     placeholder="Seleccione un usuario"
                     [ngModelOptions]="{standalone: true}"
                     [(ngModel)]="usuarioSelectedItem"
                     (change)="onUsuarioSelected($event)">
          </ng-select>
        </ng-container>
        <ng-template #loadingUsuarios>
          <app-lfsa-loading-v2></app-lfsa-loading-v2>
        </ng-template>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 text-center">
        <button type="button" class="btn btn-secondary mr-2" (click)="closeUsuarioModal()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="!usuarioSelectedItem || loading" (click)="saveUsuarioParametro()">
          <i class="fa fa-save"></i> {{ isCreateUsuario ? 'Añadir' : 'Actualizar' }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
